import { CompassCardUI } from '@scale/compass-ui/types';
import {
  OptInNotificationCardShared,
  type OptInNotificationSchemaType,
  type OptInNotificationContext,
  OPT_IN_NOTIFICATION,
} from '@scale/genai-compass-shared/cards/opt_in_notification';
import OptInNotificationCardComponent from './OptInNotificationCardComponent';
import { faBell } from '@fortawesome/pro-solid-svg-icons';

const TWO_WEEKS_TO_MS = 14 * 24 * 60 * 60 * 1000;
const DEFAULT_EXPIRE_DATE = new Date(Date.now() + TWO_WEEKS_TO_MS);

const defaultContext: OptInNotificationContext = {
  cardType: OPT_IN_NOTIFICATION,
  columnIdWithWorkerIds: '',
  assignment: { projectId: '', reviewLevel: undefined, expiresAt: DEFAULT_EXPIRE_DATE },
};

export const OptInNotificationCardInfo: CompassCardUI<
  OptInNotificationSchemaType,
  OptInNotificationContext
> = {
  ...OptInNotificationCardShared,
  title: 'Opt In Notification',
  icon: 'edit',
  toolTip: 'Send Opt-in Notification Card and Modal to eligible workers',
  defaultContext,
  ownerTeam: 'Allocation',
  showOutput: true,
  legacyComponent: OptInNotificationCardComponent,
  button: {
    icon: faBell,
  },
};
